import {store} from './store';
import AuthActions from './Auth/actions';

export default () => new Promise(() => {
    store.dispatch(AuthActions.checkAuthorization());
});
